import type { ProvidedJobPostsResponse } from '../types/ProvidedJobPost';
import { Button } from '@/components/Button';
import { linkifyText } from '@/utils/linkify';
import { Link } from '@tanstack/react-router';
import { MdEdit } from 'react-icons/md';

type Props = {
  jobPost: ProvidedJobPostsResponse | undefined;
};

export default function ProvidedJobPostsInfoCard({ jobPost }: Props) {
  if (!jobPost) {
    return (
      <div className="rounded-lg bg-white p-6 shadow">
        <p className="text-gray-500">読み込み中...</p>
      </div>
    );
  }

  return (
    <div className="">
      <div className="relative flex flex-col gap-lg rounded-sm bg-white p-lg shadow-layer1">
        <Button className="absolute top-lg right-lg" asChild color="tertiary" size="md">
          <Link
            to="/agent/provided_job_posts/$providedJobPostsId/edit"
            params={{ providedJobPostsId: jobPost.id.toString() }}
          >
            <MdEdit size={20} />
            編集
          </Link>
        </Button>
        {Array.isArray(jobPost.job_content_json) &&
          jobPost.job_content_json.length > 0 &&
          jobPost.job_content_json.map((item, index) => (
            <div key={index} className="flex flex-col gap-xs">
              <h3 className="text-heading-xs text-main">{item.key}</h3>
              <div className="text-body-sm break-words whitespace-pre-wrap text-main">
                {linkifyText(
                  item.content,
                  'text-link underline hover:text-link hover:underline hover:bg-primary_lighten'
                )}
              </div>
            </div>
          ))}
      </div>
    </div>
  );
}
